var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectAll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "select_all",
    clipPath: "url(#clip0_12350_154479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 4.16667H4.16667V2.5C3.25 2.5 2.5 3.25 2.5 4.16667ZM2.5 10.8333H4.16667V9.16667H2.5V10.8333ZM5.83333 17.5H7.5V15.8333H5.83333V17.5ZM2.5 7.5H4.16667V5.83333H2.5V7.5ZM10.8333 2.5H9.16667V4.16667H10.8333V2.5ZM15.8333 2.5V4.16667H17.5C17.5 3.25 16.75 2.5 15.8333 2.5ZM4.16667 17.5V15.8333H2.5C2.5 16.75 3.25 17.5 4.16667 17.5ZM2.5 14.1667H4.16667V12.5H2.5V14.1667ZM7.5 2.5H5.83333V4.16667H7.5V2.5ZM9.16667 17.5H10.8333V15.8333H9.16667V17.5ZM15.8333 10.8333H17.5V9.16667H15.8333V10.8333ZM15.8333 17.5C16.75 17.5 17.5 16.75 17.5 15.8333H15.8333V17.5ZM15.8333 7.5H17.5V5.83333H15.8333V7.5ZM15.8333 14.1667H17.5V12.5H15.8333V14.1667ZM12.5 17.5H14.1667V15.8333H12.5V17.5ZM12.5 4.16667H14.1667V2.5H12.5V4.16667ZM5.83333 14.1667H14.1667V5.83333H5.83333V14.1667ZM7.5 7.5H12.5V12.5H7.5V7.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12350_154479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAll);
export default __webpack_public_path__ + "static/media/selectAll.2d7326e89746f8f60e417ce10694f7e0.svg";
export { ForwardRef as ReactComponent };